import React from "react";
import { Loader2, Inbox } from "lucide-react";
import { fmtDate, fmtDateTime } from "@/lib/format";

// Mostra la data effettiva dell'evento/contatto e, sotto, l'orario di registrazione a sistema
export const EventTime = ({ dataEvento, createdAt }) => (
  <span className="text-right leading-tight shrink-0" data-testid="event-time">
    <span className="block text-xs font-medium text-slate-600">{fmtDate(dataEvento || createdAt)}</span>
    <span className="block text-[10px] text-muted-foreground">Registrato: {fmtDateTime(createdAt)}</span>
  </span>
);

export const PageHeader = ({ title, description, actions, icon: Icon }) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
    <div className="flex items-start gap-3">
      {Icon && <div className="h-11 w-11 rounded-xl bg-[color:var(--brand-orange-100)] flex items-center justify-center shrink-0"><Icon className="h-6 w-6 text-[color:var(--brand-orange-600)]" /></div>}
      <div>
        <h1 className="font-display text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
        {description && <p className="text-sm text-muted-foreground mt-0.5">{description}</p>}
      </div>
    </div>
    {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
  </div>
);

export const LoadingState = ({ label = "Caricamento in corso…" }) => (
  <div className="flex items-center justify-center py-16 text-muted-foreground" data-testid="loading-state">
    <Loader2 className="h-6 w-6 animate-spin mr-2 text-[color:var(--brand-orange-600)]" /> {label}
  </div>
);

export const EmptyState = ({ title = "Nessun elemento", description, action }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="empty-state">
    <div className="h-14 w-14 rounded-2xl bg-slate-100 flex items-center justify-center mb-3">
      <Inbox className="h-7 w-7 text-slate-400" />
    </div>
    <p className="font-medium text-slate-700">{title}</p>
    {description && <p className="text-sm text-muted-foreground mt-1 max-w-md">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
